<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-unlock-alt"></i> {{ _('Yale locks') }}</h3>
        </div>
      </div>
      <Datatable :url="locksUrl" :search="search" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import components from '~/lib/components'
import formatters from '~/lib/formatters'
import Datatable from '~/components/Datatable'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      locks: [],
      search: '',
      tableOptions: {
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'LockName',
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('House'),
          field: 'HouseName',
          widthGrow: 4,
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'LockName',
          dir: 'asc'
        }],
        rowClick (e, row) {
          $this.editRow(row)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    locksUrl () {
      return this.baseDomain + this.shopId + '/yalelocks.json?apikey=' + this.apiKey
    }
  },
  methods: {
    editRow (row) {
      let id = row.getCell('id').getValue()
      let name = row.getCell('LockName').getValue()
      this.editLock(id, name)
    },
    editLock (id, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'YaleLockDetails',
        title: this._('Lock') + (name ? ': ' + name : ''),
        width: 6,
        data: {
          lockId: id
        },
        skipState
      })
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['yaleLockUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>